module.exports = __webpack_public_path__ + "img/egg-red.87eec33c.svg";